import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

const Title = () => {
  const settings = useSelector((state) => state.settings);
  const lang = useSelector((state) => state.lang);
  return (
    <>
      <Helmet>
        <html lang={lang} className={lang === "ar" ? "rtl" : "ltr"} />
        <meta name="theme-color" content={settings.color1} />
        <title>{lang === "ar" ? settings.title_ar : settings.title}</title>
        <link
          rel="icon"
          type="image/png"
          href={settings.favicon !== "" ? settings.favicon : "/favicon.ico"}
        />
        <style id="dynamicTheme">
          {`:root{--primary-color: ${settings.color1}; --secondary-color: ${settings.color2}; --third-color: ${settings.color3}; --fourth-color: ${settings.color4};}`}
        </style>
        <body lang={lang} className={lang === "ar" ? "rtl" : "ltr"} />
      </Helmet>
    </>
  );
};

export default Title;
